import request from '@/util/request';

// 分页
export const getPageList = (params, options) =>
  request.get('/api/shunt/meter/balance-change/page', Object.assign({}, options, { params }));

// 详情
export const getDetail = (params, options) =>
  request.get('/api/shunt/meter/balance-change/detail', Object.assign({}, options, { params }));

